import { useEffect } from "react";

import { EntityType, EntityTypesSupportedByMapsPage } from "@mapmycustomers/shared/types/entity";

import { UiSyncListener } from "@app/store/uiSync/actions";

const useMapEntityUpdateListener = (
  visibleEntities: EntityTypesSupportedByMapsPage[],
  subscribe: (payload: { entityTypes: EntityType[]; listener: UiSyncListener }) => void,
  unsubscribe: (payload: { entityTypes: EntityType[]; listener: UiSyncListener }) => void,
  update: () => void
) => {
  useEffect(() => {
    if (visibleEntities.length === 0) {
      return;
    }

    const listener = {
      // Reload pins
      // TODO: we can use a more sophisticated logic in a future, e.g. only reload if modified entity
      // was even visible on maps (at least for update/delete events)
      onAdd: () => update(),
      onDelete: () => update(),
      onUpdate: () => update(),
    };
    subscribe({ entityTypes: visibleEntities, listener });
    return () => {
      unsubscribe({ entityTypes: visibleEntities, listener });
    };
  }, [subscribe, unsubscribe, update, visibleEntities]);
};

export default useMapEntityUpdateListener;
